import { Component } from '@angular/core';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { PanelType } from 'src/app/panels/models/panel-type';
import {
  KPI_PANEL_IMPORTS,
  KpiPanelComponent,
} from '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component';
import { PanelComponent } from '../../../../../panels/components/panel.component';

@PanelComponent.register
@Component({
  templateUrl: '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component.html',
  styleUrl: '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component.scss',
  selector: 'app-total-gas-used-kpi-panel',
  imports: KPI_PANEL_IMPORTS,
})
export class TotalGasUsedKpiPanelComponent extends KpiPanelComponent {
  public static override readonly type = PanelType.TotalGasUsedKpi;
  public override title = 'Totaal gasverbruik';
  public override icon = 'bi-fire';
  public override unit = DisplayUnit.M3;
}
